"use client";

import Image from "next/image";
import { ASSET_PREFIX } from "@/config";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useRef } from "react";
import EnquireNowButton from "./EnquireNowButton";

const blogData = [
   {
    img: "/images/blogs/unitd-living-space-signs-128-crore-mou-for-a-new-it-project-in-saravanampatti.webp",
    date: "27 Aug 2026",
    title: "UNITD Living Space Signs ₹128 Crore MoU for a New IT Project in Saravanampatti - What It Means for MUH",
    link: "/unitd-living-space-signs-128-crore-mou-for-a-new-it-project-in-saravanampatti",
    desc: "",
  },
  {
    img: "/images/blogs/tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore.webp",
    date: "4 Nov 2025",
    title: "TVS Nagar is next to bloom as a new residential hub for Coimbatore",
    link: "/tvs-nagar-is-next-to-bloom-as-a-new-residential-hub-for-coimbatore",
  },
  {
    img: "/images/blogs/5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore.webp",
    date: "3 Nov 2025",
    title: "5 Reasons TVS Nagar is Emerging as a Growth Hub in Coimbatore",
    link: "/5-reasons-tvs-nagar-is-emerging-as-a-growth-hub-in-coimbatore",
  },
  {
    img: "/images/blogs/top-reasons-to-invest-in-villas-plots-in-tvs-nagar.webp",
    date: "2 Nov 2025",
    title: "Top Reasons to Invest in Villas & Plots in TVS Nagar",
    link: "/top-reasons-to-invest-in-villas-plots-in-tvs-nagar",
  },
  {
    img: "/images/blogs/market-shopping-places-near-tvs-nagar.webp",
    date: "1 Nov 2025",
    title: "Markets & Shopping Places near TVS Nagar",
    link: "/market-shopping-places-near-tvs-nagar",
  },
];

function ArrowIcon({ direction }: { direction: "prev" | "next" }) {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d={direction === "prev" ? "M15 19l-7-7 7-7" : "M9 5l7 7-7 7"}
      />
    </svg>
  );
}

export default function Blogs() {
  const pathname = usePathname();
  const sliderRef = useRef<HTMLDivElement | null>(null);

  const scrollSlider = (direction: "prev" | "next") => {
    const el = sliderRef.current;
    if (!el) return;

    el.scrollBy({
      left: direction === "next" ? el.clientWidth * 0.9 : -el.clientWidth * 0.9,
      behavior: "smooth",
    });
  };

  return (
    <section className="w-[85%] max-w-[110rem] mx-auto blogs-section">
      <div className="flex justify-between flex-wrap gap-[20px] mb-[25px] sm:mb-[30px] md:mb-[40px]">
        <h2 className="text-[28px]/[36px] md:text-[32px]/[40px] lg:text-[36px]/[44px] xl:text-[40px]/[48px] 2xl:text-[48px]/[54px] text-[#000] font-[500] tracking-[-0.06em]">
          Blogs
        </h2>

        <div className="flex items-center gap-[15px] flex-wrap">
          <EnquireNowButton />

          {pathname !== "/blog" && pathname !== "/blog/" && (
            <Link
              className="group text-[#000] hover:text-[#fff] bg-[#fff] border border-[#000] rounded-[50px] px-[20px] md:px-[25px] py-[8px] md:py-[12px] w-fit gap-[15px] flex items-center justify-between transition-all duration-300 hover:bg-[#AF8E43] hover:border-[#AF8E43] cursor-pointer"
              href="/blog"
              aria-label="View all blogs"
            >
              View all
              <svg
                width="12"
                height="12"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="https://www.w3.org/2000/svg"
                className="transition-transform duration-300 group-hover:rotate-45"
                aria-hidden="true"
              >
                <path
                  d="M15.435 1.56497C15.435 1.01269 14.9873 0.564971 14.435 0.564971L5.43503 0.564972C4.88274 0.564971 4.43503 1.01269 4.43503 1.56497C4.43503 2.11726 4.88274 2.56497 5.43503 2.56497L13.435 2.56497L13.435 10.565C13.435 11.1173 13.8827 11.565 14.435 11.565C14.9873 11.565 15.435 11.1173 15.435 10.565L15.435 1.56497ZM1 15L1.70711 15.7071L15.1421 2.27208L14.435 1.56497L13.7279 0.857865L0.292893 14.2929L1 15Z"
                  fill="#000"
                  className="group-hover:fill-[#fff]"
                />
              </svg>
            </Link>
          )}
        </div>
      </div>

      <div className="block 2xl:hidden relative">
        <button
          type="button"
          onClick={() => scrollSlider("prev")}
          className="absolute left-[-20px] top-[40%] z-10 bg-[#000] text-[#fff] w-[40px] h-[40px] rounded-full flex items-center justify-center hover:bg-[#333] transition cursor-pointer"
          aria-label="Previous blog"
        >
          <ArrowIcon direction="prev" />
        </button>

        <button
          type="button"
          onClick={() => scrollSlider("next")}
          className="absolute right-[-20px] top-[40%] z-10 bg-[#000] text-[#fff] w-[40px] h-[40px] rounded-full flex items-center justify-center hover:bg-[#333] transition cursor-pointer"
          aria-label="Next blog"
        >
          <ArrowIcon direction="next" />
        </button>

        <div
          ref={sliderRef}
          className="flex gap-[25px] overflow-x-auto scroll-smooth snap-x snap-mandatory pb-[5px] [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          {blogData.map((item) => (
            <article
              key={item.link}
              className="blog-card group px-[15px] py-[15px] hover:bg-[#fff] transition duration-300 ease-in-out hover:shadow-md relative snap-start shrink-0 w-full min-[480px]:w-[83%] sm:w-[62.5%] md:w-[calc(50%-13px)] lg:w-[calc(33.333%-17px)] xl:w-[31%]"
            >
              <div className="overflow-hidden flex">
                <Image
                  src={`${ASSET_PREFIX}${item.img}`}
                  alt={item.title}
                  width={400}
                  height={250}
                  sizes="(max-width: 480px) 85vw, (max-width: 768px) 63vw, (max-width: 1280px) 33vw, 400px"
                  loading="lazy"
                  className="w-full h-auto object-cover object-center group-hover:scale-[1.05] transition duration-300 ease-in-out"
                />
              </div>

              <p className="mb-[10px] mt-[25px] tracking-[-0.03em] text-[#000]">
                {item.date}
              </p>
              <h3 className="text-[18px] leading-[26px] mt-[18px] font-[500] mb-[15px] tracking-[-0.03em] text-[#000]">
                {item.title}
              </h3>

              <Link className="inset-0 absolute" href={item.link} aria-label={`Read blog: ${item.title}`} />
            </article>
          ))}
        </div>
      </div>

      <div className="hidden 2xl:grid grid-cols-4 gap-[25px]">
        {(pathname !== "/blog/" ? blogData.slice(0, 4) : blogData).map((item) => (
          <article
            key={item.link}
            className="blog-card group px-[20px] py-[15px] transition duration-300 ease-in-out relative"
          >
            <div className="overflow-hidden flex">
              <Image
                src={`${ASSET_PREFIX}${item.img}`}
                alt={item.title}
                className="w-full h-auto object-cover object-center group-hover:scale-[1.05] transition duration-300 ease-in-out"
                width={400}
                height={250}
                sizes="25vw"
                loading="lazy"
              />
            </div>

            <p className="mb-[10px] mt-[25px] tracking-[-0.03em] text-[#000]">
              {item.date}
            </p>
            <h3 className="text-[18px] leading-[26px] mt-[18px] font-[500] mb-[15px] tracking-[-0.03em] text-[#000]">
              {item.title}
            </h3>
            <div className="mt-[35px]">
              <Link href={item.link}>View More</Link>
            </div>

            <Link href={item.link} className="inset-0 absolute" aria-label={`Read blog: ${item.title}`} />
          </article>
        ))}
      </div>
    </section>
  );
}
